








































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import AcademicTitle from '@/models/academic/academicTitle.model';
@Component
export default class AcademicTitleEdit extends GenericEdit<AcademicTitle> {
  constructor() {
    super();
    this.controller = 'AcademicTitle';
    this.model = new AcademicTitle();
  }
}
